import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance.tsx";

export class ReportCategoryApiService {
    private readonly reportCategoryBaseUrl: string;

    constructor() {
        this.reportCategoryBaseUrl = ApiConstants().reportCategory;
    }

    async getReportCategories(): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.reportCategoryBaseUrl}`,
            requiresToken: true,
        });
        return response;
    }
}